import { useMemo } from 'react';

import find from 'lodash/find';

import {
  LaborLevelResponse,
  useEmployeeLaborLevelWithOptionsGet,
} from '@sbv-clients/data-access-api';

import {
  BaseFieldProps,
  createOptionsFieldBuilder,
} from '../hoc/fields-builder';

const defaultGetLaborLevelLevelLabel = (child: LaborLevelResponse): string =>
  `${child.laborLevelId} - ${child.laborLevelDescription}`;

const useOptionsHook = ({
  getLaborLevelLevelLabel = defaultGetLaborLevelLevelLabel,
  pkEmployeeId,
  level,
}: Parameters<typeof useEmployeeLaborLevelWithOptionsGet>[0] & {
  getLaborLevelLevelLabel?: (child: LaborLevelResponse) => string;
  level: number;
}) => {
  const {
    options: baseOptions,
    isLoading,
    isSuccess,
  } = useEmployeeLaborLevelWithOptionsGet(
    { pkEmployeeId },
    { getLaborLevelLevelLabel }
  );
  const options = useMemo(() => {
    return (
      find(baseOptions, (item) => item.meta.level === level)?.children ?? []
    );
  }, [baseOptions, level]);
  return { options, isLoading, isSuccess };
};

type ExtraParameters = Parameters<typeof useOptionsHook>[0];

type Props = BaseFieldProps & ExtraParameters;

const hookParamsGetter = (props: Props): ExtraParameters => props;

export const { EmployeeLaborLevelLevelsFormSelectField } =
  createOptionsFieldBuilder({
    prefix: 'EmployeeLaborLevelLevels',
    useOptionsHook: useOptionsHook,
    extractHookParams: hookParamsGetter,
  });
